export default __webpack_public_path__ + "static/media/brown_anim.7d325d0d.gif";